/**
 * Auth context definition
 *
 * Separated from AuthProvider component to satisfy react-refresh requirements.
 */

import { createContext } from 'react';
import type { AuthContextValue } from '../types/auth.types';

export const AuthContext = createContext<AuthContextValue | null>(null);
